// Author Liang Gang Qiang
// Date 2021-11-27 10:12:22

class MintalMesQualityProductionSampleItem {
constructor({
        id = null,
        sampleId = '',
        sampleCode = '',
        projectItemId = '',
        measurement = '',
        inspector = '',
        inspectTime = '',
        qualified = '',
        status = '',
        remark = '',
        index = ''}
= {}) {
    this.id = id;
    this.sampleId = sampleId;
    this.sampleCode = sampleCode;
    this.projectItemId = projectItemId;
    this.measurement = measurement;
    this.inspector = inspector;
    this.inspectTime = inspectTime;
    this.qualified = qualified;
    this.status = status;
    this.remark = remark;
    this.index = index;
}
}

function newEntity() {
return new MintalMesQualityProductionSampleItem();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.mintal.quality.mintalMesQualityProductionSampleItem.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'sampleName',
        label: 'label.mintal.quality.mintalMesQualityProductionSampleItem.grid.sampleName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'compoundFormula',
        label: 'label.mintal.quality.mintalMesQualityProductionSampleItem.grid.compoundFormula',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'compoundName',
        label: 'label.mintal.quality.mintalMesQualityProductionSampleItem.grid.compoundName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'upperLimit',
        label: 'label.mintal.quality.mintalMesQualityProductionSampleItem.grid.upperLimit',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'lowerLimit',
        label: 'label.mintal.quality.mintalMesQualityProductionSampleItem.grid.lowerLimit',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'compoundUnit',
        label: 'label.mintal.quality.mintalMesQualityProductionSampleItem.grid.compoundUnit',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'measurement',
        label: 'label.mintal.quality.mintalMesQualityProductionSampleItem.grid.measurement',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'inspector',
        label: 'label.mintal.quality.mintalMesQualityProductionSampleItem.grid.inspector',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'inspectTime',
        label: 'label.mintal.quality.mintalMesQualityProductionSampleItem.grid.inspectTime',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'qualified',
        label: 'label.mintal.quality.mintalMesQualityProductionSampleItem.grid.qualified',
        sortable: true,
        form: {
        type: 'select'
        ,options: [
                { value: '0', text: '无' },
                            { value: '1', text: '合格' },
                            { value: '2', text: '一级品' },
                            { value: '3', text: '二级品' },
                            { value: '4', text: '不合格' }
            ],
            customClass: (row) => {
                if (row.qualified === 4) {
                    return "text-danger font-weight-bold";
                }
                return "";
            }
        }
        },
        {
        key: 'status',
        label: 'label.mintal.quality.mintalMesQualityProductionSampleItem.grid.status',
        sortable: true,
        form: {
        type: 'select'
        ,options: [
                { value: '1', text: '已保存' },
                            { value: '2', text: '已报检' },
                            { value: '3', text: '已接收' },
                            { value: '4', text: '检验中' },
                            { value: '5', text: '已完成' },
                            { value: '6', text: '复测中' }
            ]
        }
        },
        {
        key: 'remark',
        label: 'label.mintal.quality.mintalMesQualityProductionSampleItem.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        },
        {
        key: 'index',
        label: 'label.mintal.quality.mintalMesQualityProductionSampleItem.grid.index',
        sortable: true,
        form: {
        type: 'input'
        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    sampleIdFilter : '',
    sampleCodeFilter : '',
    qualityProjectIdFilter : '',
    measurementFilter : '',
    inspectorFilter : '',
    inspectTimeRteFilter : '',
    inspectTimeLteFilter : '',
    qualifiedFilter : '',
    statusFilter : '',
    indexFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'sampleCodeFilter',
        label: 'label.mintal.quality.mintalMesQualityProductionSampleItem.filter.sampleCode',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'mintalMesQualityProductionSample'
            ,correspondingField: 'code'
            ,fieldsBindingByEntityModalSelected: '{"sampleId": "id"}'
                }
        },
        {
        key: 'measurementFilter',
        label: 'label.mintal.quality.mintalMesQualityProductionSampleItem.filter.measurement',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'inspectorFilter',
        label: 'label.mintal.quality.mintalMesQualityProductionSampleItem.filter.inspector',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'inspectTimeRteFilter',
        label: 'label.mintal.quality.mintalMesQualityProductionSampleItem.filter.inspectTimeRte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'inspectTimeLteFilter',
        label: 'label.mintal.quality.mintalMesQualityProductionSampleItem.filter.inspectTimeLte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'qualifiedFilter',
        label: 'label.mintal.quality.mintalMesQualityProductionSampleItem.filter.qualified',
        disabled: false,
        form: {
        type: 'select'
            ,showLabelSelectOne: true
         ,options: [
                { value: '0', text: '无' },
                { value: '1', text: '合格' },
                { value: '2', text: '一级品' },
                { value: '3', text: '二级品' },
                { value: '4', text: '不合格' }
            ]
        }
        },
        {
        key: 'statusFilter',
        label: 'label.mintal.quality.mintalMesQualityProductionSampleItem.filter.status',
        disabled: false,
        form: {
        type: 'select'
            ,showLabelSelectOne: true
         ,options: [
                { value: '1', text: '已保存' },
                { value: '2', text: '已报检' },
                { value: '3', text: '已接收' },
                { value: '4', text: '检验中' },
                { value: '5', text: '已完成' },
                { value: '6', text: '复测中' }
            ]
        }
        },
        {
        key: 'indexFilter',
        label: 'label.mintal.quality.mintalMesQualityProductionSampleItem.filter.index',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'sampleCode',
        label: 'label.mintal.quality.mintalMesQualityProductionSampleItem.entity.sampleCode',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'mintalMesQualityProductionSample'
            ,correspondingField: 'code'
            ,fieldsBindingByEntityModalSelected: '{"sampleId": "id"}'
                }
        },
        {
        key: 'projectItemId',
        label: 'label.mintal.quality.mintalMesQualityProductionSampleItem.entity.projectItemId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entitySelect'
            ,entity: 'mintalMesQualityProjectItem'
            ,showLabelSelectOne: true
                }
        },
        {
        key: 'measurement',
        label: 'label.mintal.quality.mintalMesQualityProductionSampleItem.entity.measurement',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'remark',
        label: 'label.mintal.quality.mintalMesQualityProductionSampleItem.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        },
        {
        key: 'index',
        label: 'label.mintal.quality.mintalMesQualityProductionSampleItem.entity.index',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        }
]

export {MintalMesQualityProductionSampleItem, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
